import { create } from "zustand";

import { SearchRequest } from "../api/customer";

export interface SearchState {
  omneName: string;
  dob: string;
  phoneNumber: string;
  email: string;
  policyNumber: string;
  insuranceCountry: string[];
  signUpCountry: string[];
}

type State = SearchState;

type Actions = {
  actions: {
    setState: (state: SearchState) => void;
  };
};

const SearchStore = create<State & Actions>(set => ({
  // State
  omneName: "",
  dob: "",
  phoneNumber: "",
  email: "",
  policyNumber: "",
  insuranceCountry: [],
  signUpCountry: [],

  // Actions
  actions: {
    setState: newState =>
      set(() => ({
        ...newState,
      })),
  },
}));

export const useSearchStore = () => {
  return SearchStore(store => ({
    omneName: store.omneName,
    dob: store.dob,
    phoneNumber: store.phoneNumber,
    email: store.email,
    policyNumber: store.policyNumber,
    insuranceCountry: store.insuranceCountry,
    signUpCountry: store.signUpCountry,
  }));
};

export const useSetSearchStore = () => {
  return SearchStore(store => store.actions.setState);
};

type queryState = SearchRequest;

type ActionsQuery = {
  actions: {
    setQueryString: (queryString: SearchRequest) => void;
  };
};

const QuerySearchStore = create<queryState & ActionsQuery>(set => ({
  // State
  omneName: "",
  dob: "",
  phoneNumber: "",
  email: "",
  policyNumber: "",
  insuranceCountry: "",
  signUpCountry: "",
  pagination: {
    currentPage: 1,
    pageSize: 12,
  },
  permission_Token: "",

  // Actions
  actions: {
    setQueryString: queryString =>
      set(() => ({
        ...queryString,
      })),
  },
}));

export const useSearchQuery = () =>
  QuerySearchStore(store => ({
    queryString: {
      omneName: store.omneName,
      dob: store.dob,
      phoneNumber: store.phoneNumber,
      email: store.email,
      policyNumber: store.policyNumber,
      insuranceCountry: store.insuranceCountry,
      signUpCountry: store.signUpCountry,
      pagination: {
        currentPage: store.pagination.currentPage,
        pageSize: store.pagination.pageSize,
      },
      permission_Token: store.permission_Token,
    },
    setQueryString: store.actions.setQueryString,
  }));
